import React from 'react';
import T from 'prop-types';
import Field from 'shared/components/field';
import RichTextEditor from 'shared/components/rich-text-editor';

const RichTextField = ({
  onChange,
  meta,
  propName,
  value,
  label,
  help,
  placeholder,
  isRequired,
}) => (
  <Field name={propName} label={label} meta={meta} isRequired={isRequired} help={help}>
    <RichTextEditor
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      invalid={typeof meta.error === 'string'}
    />
  </Field>
);

RichTextField.propTypes = {
  show: T.object,
  onChange: T.func.isRequired,
  meta: T.object,
  propName: T.string.isRequired,
  value: T.string,
  label: T.string,
  help: T.string,
  placeholder: T.string,
  isRequired: T.bool,
};

export default RichTextField;
